import overrideIfMinBetNumberEnabled from "./MinBetNumberRegistrator";
overrideIfMinBetNumberEnabled(function () {
    (function (slipShared) {
        if (!slipShared) {
            return;
        }
        const getMBNIndicationClass = function (MBNNumber) {
            switch (MBNNumber) {
                case 1:
                    return "min-bet-number--one";
                case 2:
                    return "min-bet-number--two";
                case 3:
                    return "min-bet-number--three";
                default:
                    return "min-bet-number--one";
            }
        };
        $.extend(slipShared, {
            donotDrawMBNIndicatorIconForNextBranchesArr: [eBranches.GreyHoundsRacing, eBranches.HorseRacing, eBranches.VirtualSports, eBranches.VirtualSports_, eBranches.VirtualSports2Way, eBranches.VirtualSports3Way],
            createMinBetNumberIcon(selection) {
                var minBetNumber = selection.MinBetNumber;
                var skip = Number(minBetNumber) !== minBetNumber || this.donotDrawMBNIndicatorIconForNextBranchesArr.indexOf(selection.BranchID) > -1;
                if (skip) {
                    return "";
                }
                var mbnIndicationClass = getMBNIndicationClass(minBetNumber);
                return `<span class="min-bet-number ${mbnIndicationClass}" data-uat="mbn-indication">${minBetNumber}</span>`;
            }
        });
        var _createBetTypeRow = slipShared.createBetTypeRow;
        $.extend(slipShared, {
            createBetTypeRow(lineEventTypeName, selection, tsSelection, mode) {
                return `
                    <div class="event_desc-mbn-wrapper">
                        ${this.createMinBetNumberIcon(selection)}
                        ${_createBetTypeRow.apply(this, arguments)}
                    </div>
                `;
            }
        });
    })(window.TSlipShared);
});
//# sourceMappingURL=TSlipShared.js.map